import { globalPrompt } from "@/components/YhMessage";
import useNavModel from "@/model/navModel";
import { ciHttpRequest } from '../../../utils/CiHttpRequest';


export default function BillDetailRender(text: string, branch: string, tradeCode: string, tradeTypeCode: string) {

  const branchList = new Set([
    "scm",
    "vrm",
    "ci",
    "bcm"
  ])
  const tradeTypeList = new Set([
    "trade-type.sale",
    "trade-type.sale-return",
    "trade-type.purchase",
    "trade-type.purchase-return",
    "trade-type.maintenance",
    "trade-type.maintenance-return"
  ])
  const { selectedNavId, replaceNav } = useNavModel();

  const goToBill = () => {
    if (!branchList.has(branch as string)) return globalPrompt("message", { text: "暂不支持查看此系统账单详情", type: "warning" })
    if (!tradeTypeList.has(tradeTypeCode as string)) return globalPrompt("message", { text: "暂不支持查看此类型账单详情", type: "warning" })

    if (tradeTypeCode === 'trade-type.sale-return' && branch === "scm") {
      replaceNav(
        selectedNavId,
        "10-1",
        {
          id: tradeCode as string,
          mode: '',
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (tradeTypeCode === 'trade-type.sale' && branch === "scm") {
      replaceNav(
        selectedNavId,
        "10-2",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)

    } else if (tradeTypeCode === 'trade-type.purchase-return' && branch === "scm") {
      replaceNav(
        selectedNavId,
        "10-4",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (tradeTypeCode === 'trade-type.purchase' && branch === "scm") {
      replaceNav(
        selectedNavId,
        "10-3",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (tradeTypeCode === 'trade-type.sale' && branch === "ci") {
      replaceNav(
        selectedNavId,
        "11-2",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (tradeTypeCode === 'trade-type.sale-return' && branch === "vrm") {
      replaceNav(
        selectedNavId,
        "11-1",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (tradeTypeCode === 'trade-type.maintenance' && branch === "ci") {
      replaceNav(
        selectedNavId,
        "11-5",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (tradeTypeCode === 'trade-type.maintenance-return' && branch === "vrm") {
      replaceNav(
        selectedNavId,
        "11-6",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (tradeTypeCode === 'trade-type.purchase-return' && branch === "vrm") {
      replaceNav(
        selectedNavId,
        "11-4",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (tradeTypeCode === 'trade-type.purchase' && branch === "vrm") {
      replaceNav(
        selectedNavId,
        "11-3",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (tradeTypeCode === 'trade-type.sale-return' && branch === "bcm") {
      replaceNav(
        selectedNavId,
        "12-1",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (tradeTypeCode === 'trade-type.sale' && branch === "bcm") {
      replaceNav(
        selectedNavId,
        "12-2",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (tradeTypeCode === 'trade-type.transit-sale' && branch === "bcm") {
      replaceNav(
        selectedNavId,
        "12-7",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (tradeTypeCode === 'trade-type.transit-sreturn' && branch === "bcm") {
      replaceNav(
        selectedNavId,
        "12-6",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (tradeTypeCode === 'trade-type.maintenance' && branch === "bcm") {
      replaceNav(
        selectedNavId,
        "12-5",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    } else if (tradeTypeCode === 'trade-type.purchase-return' && branch === "bcm") {
      replaceNav(
        selectedNavId,
        "12-4",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)

    } else if (tradeTypeCode === 'trade-type.purchase' && branch === "bcm") {
      replaceNav(
        selectedNavId,
        "12-3",
        {
          id: tradeCode as string,
          mode: "",
          branch: branch as string,
          parentInfo: {
            selectedNavId,
          }
        },
        true)
    }
  }

  return <p className="ellipsis" style={branchList.has(branch as string) && tradeTypeList.has(tradeTypeCode as string) ? { color: 'blue' } : {}} onClick={goToBill}>{text}</p>
}